<template>
  <div :class="styleClass">
    <div class="box_title_area">
      <h3 class="service-title-b">방문하실 ABC를 선택해주세요.</h3>
      <p>
        ABC 내 마이 팩 바이 뉴트리라이트 랩 담당 직원의 확인 완료 후 결제 및
        수령이 진행됩니다.
      </p>
    </div>
    <div class="choice-abc">
      <span class="form_select-default">
        <select
          v-model="selectedABC"
          id="pickupAp"
          :disabled="!abcFectched"
          class="form_select"
          title="구분번호를 선택하세요"
          data-default-pickup-ap="bundang"
          @change="$emit('input', $event.target.value)"
        >
          <option value="">선택하세요</option>
          <option v-for="abc in abcLocation" :key="abc.cd" :value="abc.cd">
            {{ abc.cdName }}
          </option>
        </select>
      </span>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ABCSection",
  props: {
    value: {
      type: String,
      default: "",
    },
    styleClass: {
      type: String,
      default: "abc-select-box",
    },
  },
  data() {
    return {
      selectedABC: this.value,
    };
  },
  mounted() {
    const isValidABC = this.abcLocation.some(
      (item) => item.cd === this.selectedABC
    );

    if(!isValidABC) {
      console.log("invalid ABC : ", this.selectedABC);
      this.selectedABC = "bundang";
      this.$emit('input', this.selectedABC);
    }
  },
  computed: {
    ...mapGetters({
      abcLocation: "common/abc",
      abcFectched: "common/abcFectched",
    }),
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/composition/main/step3/ABCSection.vue